import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IdleTimer from 'react-idle-timer';
import apiClient from '../lib/apiClient';

const CHECK_IDLE_INTERVAL = 1000 * 60; // 60 second check interval - change to something shorter for testing
const LAST_ACTION_TIME_KEY = 'lastActionTime';
const LAST_VALIDATE_TIME_KEY = 'lastValidateTime';

const IdleTimeWatcher = props => {
  const { enabled } = props;
  const interval = useRef(null);

  useEffect(() => {
    if (enabled && !interval.current) {
      resetLastValidate();
      resetActionTimer();
      interval.current = setInterval(() => {
        checkIdleTime();
      }, CHECK_IDLE_INTERVAL);
    } else if (!enabled && interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }

    // Cleanup
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [enabled]);

  let eventTypes = [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'MSPointerDown',
    'MSPointerMove'
  ];

  return (
    <div className="idle-time-watcher">
      <IdleTimer
        events={eventTypes}
        startOnMount={false}
        element={document}
        onAction={resetActionTimer}
        throttle={1000} // milliseconds
      />
    </div>
  );
};

IdleTimeWatcher.propTypes = {
  enabled: PropTypes.bool
};

IdleTimeWatcher.defaultProps = {
  enabled: false
};

export default IdleTimeWatcher;

/**
 * Restart the react-idle-timer IdleTimer instance
 */
export const resetLastValidate = () => {
  window.localStorage.setItem(LAST_VALIDATE_TIME_KEY, Date.now());
};

export const resetActionTimer = () => {
  window.localStorage.setItem(LAST_ACTION_TIME_KEY, Date.now());
};

const checkIdleTime = () => {
  // Use local storage to coordinate across multiple browser tabs the last time we called renew to throttle the renew calls
  let lastValidateTime = window.localStorage.getItem(LAST_VALIDATE_TIME_KEY);
  let lastActionTime = window.localStorage.getItem(LAST_ACTION_TIME_KEY);
  if (lastActionTime > lastValidateTime) {
    // Last action came after last session renew, so renew now
    apiClient.apiGet('/api/util/session-data/renew').then(() => {
      resetLastValidate();
    });
  }
};
